<div class="auth-wrapper">

  <div class="auth-card">

    <div class="auth-header">
      <h2>Welcome Back 2</h2>
      <p>Please sign in to continue</p>
    </div>

    <!-- Email Field -->
    <div class="input-container">
      <i class="bi bi-envelope input-icon"></i>
      <input [(ngModel)]="email" type="email" placeholder="Email address" />
    </div>

    <!-- Password Field -->
    <div class="input-container">
      <i class="bi bi-lock input-icon"></i>

      <input [type]="showPassword ? 'text' : 'password'" [(ngModel)]="password" placeholder="Password" />

      <i class="eye-icon" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"
        (click)="toggleShowPassword()"></i>
    </div>

    <!-- Login Button -->
    <button class="btn-primary login-btn" (click)="loginAsUser()">
      Login
    </button>

  </div>

</div>